export default __webpack_public_path__ + "static/media/MC-4.18e882db.gif";